<template>
  <!-- 业务页签账单详情弹出框 -->
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_InternationalBill')"
    fullscreen
    append-to-body
    :close-on-click-modal="false"
    class="oversea-bill-detail"
  >
    <div :style="'min-width: 1600px;' + (expandedGrid || !showBillForm ? 'height: 100%;display: flex;flex-direction: column;' : '')">
      <!--账单详情表单-->
      <div
        v-show="!expandedGrid"
        class="app-main-inner-row oversea-bill-detail-form-wrapper"
      >
        <bill-form
          v-if="showBillForm"
          :billing="billing"
          :billing-form-params="billingFormParams"
          :is-view="true"
          :request-source="requestSource"
        />
      </div>
      <div class="app-main-inner-row" style="justify-content: center;font-size:30px;">
        <i :class="expandedGrid?'el-icon-caret-bottom':'el-icon-caret-top'" @click="expandedGrid=!expandedGrid" />
      </div>
      <div class="app-main-inner-row" style="justify-content: space-between">
        <div />
      </div>
      <div class="app-main-inner-row" style="justify-content: space-between">
        <div v-show="isView" class="section">
          <el-radio-group v-model="reconciliationType" no="reconciliationMode" @change="reconciliationTypeChangeHandler">
            <el-radio no="viewedByJob" label="job">{{ $t('CargoMsg.Cargo_ViewedByJob') }}</el-radio>
            <el-radio no="viewedByFee" label="charge" style="margin-right:10px">{{ $t('CargoMsg.Cargo_ViewedByFee') }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="app-main-inner-row row-grid" :style="expandedGrid||!showBillForm?'flex-grow: 1;':'height:300px'">
        <cargo-ag-grid
          :config-module="reconciliationType === 'job'?'1301253':'1301252'"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'auto'}"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>
    <div slot="footer">
      <el-button v-permission="['button_billTab_invoiceFromBilling']" :disabled="applyInvoiceDisabled" type="primary" @click="onApplyInvoiceClick(billing)">{{ $t('Billing.ApplyForInvoicing') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BillForm from './billForm'
import { getBillingDetail, loadJobOfBilling } from '@/api/clearing/billingNative'
import { Billing } from '@/class/model/act/Billing'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { loadChargeOfBilling } from '@/api/clearing/billingNative'
import BillDetailHp from '@/components/Cargo/Act/billDetailHp'
import { cache, cacheName } from '@/utils/cacheManager'
import * as NumberUtils from '@/utils/NumberUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getLoading } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'OverseaBillDialog',
  components: { BillForm },
  props: {
    visible: { type: Boolean, required: true },
    rType: { type: String, default: 'charge' },
    billingUuid: { type: String, required: true },
    newCharges: { type: Array },
    currentBillingBranchId: { type: Number },
    departmentTeamUser: { type: Array },
    createOverseaCharge: { type: Boolean, required: false }, // 是否允许国外费用开票
    showWhtTax: { type: Boolean, default: false }
  },
  data() {
    return {
      billDetailHp: new BillDetailHp(this),
      innerVisible: false,
      loading: false,
      reconciliationType: 'charge',
      isView: true,
      showConflictChargeDialog: false, // 费用冲突显示弹出窗
      conflictCharges: [], // 账单保存时有冲突的费用集合
      showJoinChargeDialog: false,
      searchItemModule: '5042',
      addChargeCondition: {
        // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        accountId: 0
      },
      expandedGrid: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressColumnVirtualisation: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        getRowStyle: function(params) {
          const data = params.data
          if (data) {
            if (data.entity === 'charge') {
              if (data.hasOwnProperty('chargeVerifiedAmount')) {
                return (data.chargeConfirmState > 0 || data.chargeVerifiedAmount !== 0) ? { background: '#EFEFEF' } : { background: 'white' }
              } else {
                return data.chargeConfirmState > 0 ? { background: '#EFEFEF' } : { background: 'white' }
              }
            } else {
              return data.jobConfirmState > 0 ? { background: '#EFEFEF' } : { background: 'white' }
            }
          }
        }
      },
      gridApi: null,
      rowData: [],
      billing: new Billing().fillDefaultValue().getData(),
      requestSource: 'booking', // 用于账单保存 标识 业务tab 入口保存账单
      billingFormParams: {
        // 账单详情页 相关信息数据(除账单以为的数据)
        sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3Enable: true, // 第三行汇率是否可编辑，默认不可编辑}
        billingNoteContainInvoiceReques: 0 // 票开账单包含开票要求，开票时可以根据开票要求，直接开票
      },
      showBillForm: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      isSaveBillRate: false // 是否使用账单汇率进行计算
    }
  },
  computed: {
    applyInvoiceDisabled() {
      return !this.billingUuid || this.rowData.findIndex(p => p.needInvoice) < 0
    },
    columnDefs() {
      let result = []
      if (this.reconciliationType === 'job') {
        result = [
          {
            headerName: '', checkboxSelection: true, width: 55,
            sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobJobNo', width: 150 },
          {
            headerName: this.$t('Billing.billingJob_customer'), field: 'jobCustomerId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingCharge_mblNo'), field: 'jobMbl', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobImportHbl', initialWidth: 200 },
          { headerName: this.$t('Invoice.invoice_containerNo'),
            field: 'containerContainerNo',
            cellRenderer: (params) => {
              if (params.value) {
                if (params.value.indexOf(',') === 0) {
                  params.value = params.value.substring(1, params.value.length)
                } else if (params.value.substring(params.value.length - 1, params.value.length) === ',') {
                  params.value = params.value.substring(0, params.value.length - 1)
                }
              }
              return params.value
            },
            initialWidth: 200
          },
          {
            headerName: this.$t('Billing.billingCharge_carrier'), field: 'jobCarrierId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'), field: 'jobVesselFlight', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_portOfDischarge'), field: 'jobDischargingPortCode', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          { headerName: 'SoNo', field: 'jobSoNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_dateOfDeparture'), field: 'jobEtd', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_bookingAgent'), field: 'jobBookingAgent', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_operation'), field: 'jobOp', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_sales'), field: 'jobSales', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_businessType'), field: 'jobLob', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Billing.billingCharge_currency'), field: 'jobChargeCurrency', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'jobAr', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_chargesTotalAmount'), field: 'jobChargeAmountTotal', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          }
        ]
      } else {
        result = [
          {
            headerName: '', checkboxSelection: true, initialWidth: 55,
            sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobJobNo', width: 150 },
          { headerName: 'SoNo', field: 'jobSoNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingCharge_mblNo'), field: 'jobMbl', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobImportHbl', initialWidth: 200 },
          { headerName: this.$t('Invoice.invoice_containerNo'), field: 'jobContainerNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'), field: 'jobVesselFlight', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingCharge_chargeItem'), field: 'chargeChargeItemId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_paymentType'), field: 'chargeReceivable', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingForm_collectAndPrepaidOrNot'), field: 'chargeAdvance', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          { headerName: this.$t('Billing.billingCharge_currency'), field: 'chargeCurrency', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingForm_unit'), field: 'chargeMeasure', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_amount'), field: 'chargeQuantity', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_unitPrice'), field: 'chargeUnitRate', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_taxIncludedPrice'), field: 'chargeAmount', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_taxExcludedPrice'),
            field: 'chargeExcludingTaxAmount',
            initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_taxRate'), field: 'chargeTaxRate', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_taxAmount'), field: 'chargeTaxAmount', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_reconciliationAmount'), field: 'chargeBillingAmount', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_difference'), field: 'chargeDiffAmount', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_confirmState'), field: 'chargeConfirmState', initialWidth: 100,
            valueFormatter: (params) => {
              if (Number(params.value) === 1) {
                return this.$t('Message.Confirmed')
              } else {
                return this.$t('Message.Unconfirmed')
              }
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_confirmationRemarks'), field: 'chargeConfirmRemarks', initialWidth: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'chargeChanger',
            field: 'chargeChanger',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_remarks'),
            colId: 'chargeRemarks',
            field: 'chargeRemarks',
            initialWidth: 180
          },
          {
            headerName: this.$t('FinanceManage.charge_invoiceHeader'),
            field: 'chargeInvoiceTitle',
            hide: true,
            width: 100
          }, {
            headerName: this.$t('FinanceManage.international_settlementAgent'),
            field: 'chargeSettlementAgentId',
            width: 150,
            hide: true,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
            }
          },
          { headerName: this.$t('Billing.billingCharge_itemNo'), field: 'jobPono', initialWidth: 200, hide: true },
          {
            headerName: this.$t('FinanceManage.charge_relatedContainerNo'),
            field: 'relationContainerNo',
            colId: 'relationContainerNo',
            width: 200,
            hide: true
          }
        ]
      }
      if (this.billingFormParams.billingNoteContainInvoiceReques) {
        result.push({
          headerName: this.$t('Billing.billingCharge_sales'), field: 'jobSales', initialWidth: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_profitMargin'), field: 'profitMargin', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LinesArAp'), field: 'lineNumber', width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_RInPay'), field: 'arIncludeAp', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.IsBookedLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GPExplain'), field: 'explainGp', width: 100
        })
      }
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'chargeNotWhtAmount',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        })
      }
      return result
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  },
  beforeMount() {
    if (this.visible) {
      this.innerVisible = true
      this.onShow()
    }
  },
  methods: {
    getInvoiceUuidsFromCharges(charges) {
      const keys = new Set()
      for (const c of (charges || [])) {
        if (c && c.needInvoice && !StrUtils.isEmpty(c.invoiceUuid)) {
          keys.add(c.invoiceUuid)
        }
      }
      return Array.from(keys)
    },
    hasUnInvoicedNeedInvoiceCharge(charges) {
      for (const c of (charges || [])) {
        if (c && c.needInvoice && StrUtils.isEmpty(c.invoiceUuid)) return true
      }
      return false
    },
    onApplyInvoiceClick(billing) {
      const charges = this.rowData || []
      const invoiceUuids = this.getInvoiceUuidsFromCharges(charges)
      const hasUnInvoiced = this.hasUnInvoicedNeedInvoiceCharge(charges)
      if (!hasUnInvoiced && invoiceUuids.length > 0) {
        if (this.$listeners && this.$listeners.viewInvoice) {
          this.$emit('viewInvoice', invoiceUuids)
          return
        }
      }
      this.$emit('applyInvoice', billing)
    },
    async onShow() {
      await cache.load(cacheName.CONFIG)
      this.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
      this.billingFormParams.billingNoteContainInvoiceReques = Number(cache.config.get('BillingNoteContainInvoiceReques'))
      this.reconciliationType = this.rType
      // 数据初始化
      this.rowData = []
      this.billing = new Billing().fillDefaultValue().getData()
      this.queryBillingDetail()
    },
    // 查询账单详情
    queryBillingDetail() {
      getBillingDetail(this.billingUuid).then((res) => {
        this.billing = { ...res.data }
        this.billing.currentOfficeId = this.$store.getters.currentOfficeId // 当前分公司
        const billing = this.billing
        billing.removedCharges = []
        billing.createCharges = []
        billing.updateCharges = []
        // 默认查询对账单关联的账单信息
        const uuid = billing.uuid
        if (uuid) {
          this.queryChargeOfBilling()
        }
        this.billDetailHp.querySettlement(billing.accountId)
        this.showBillForm = true
      })
    },
    // 查询账单关联的费用信息
    queryChargeOfBilling() {
      this.loading = getLoading()
      const requestBody = { branchId: 0, billingKey: this.billing.uuid, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, requestSource: 'BillingDetail_Charge', paging: false }
      requestBody.currentBillingBranchId = this.$store.getters.currentOfficeId
      loadChargeOfBilling(requestBody).then(res => {
        if (res.data) {
          this.rowData = [...res.data.list]
        } else {
          this.rowData = []
        }
        this.billDetailHp.refreshBilling()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询账单关联的业务信息
    queryJobOfBilling() {
      this.loading = getLoading()
      const requestBody = { branchId: 0, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, requestSource: 'BillingDetail_Job', paging: false }
      requestBody.currentBillingBranchId = this.$store.getters.currentOfficeId
      if (this.billing.uuid) { // 针对于已经创建好的账单查询
        requestBody.billingKey = this.billing.uuid
      } else { // 针对于新增未保存的账单查询,根据费用UUID查询
        requestBody.chargeKeys = this.newCharges
      }
      loadJobOfBilling(requestBody).then(async res => {
        if (res.data.list && res.data.list.length > 0) {
          this.rowData = [...res.data.list]
          let charges = []
          for (let i = 0; i < res.data.list.length; i++) {
            const job = res.data.list[i]
            const jobCharges = job['charges']
            if (jobCharges && jobCharges.length > 0) {
              charges = charges.concat(jobCharges)
              // 对所有费用的chargeNotWhtAmount字段求和
              let totalNotWhtAmount = 0
              let totalWhtTaxLocalAmount = 0
              let totalWhtTaxRate = 0
              for (const charge of jobCharges) {
                totalWhtTaxRate += charge['whtTaxRate'] || 0
                totalWhtTaxLocalAmount += charge['whtTaxLocalAmount'] || 0
                totalNotWhtAmount += charge['chargeNotWhtAmount'] || 0
              }
              job['chargeNotWhtAmount'] = totalNotWhtAmount
              job['whtTaxLocalAmount'] = totalWhtTaxLocalAmount
              job['whtTaxRate'] = totalWhtTaxRate
            }
          }
        } else {
          this.rowData = []
        }
        // 新建账单时，加载费用明细后重新计算账单
        if (this.billing && !this.billing.uuid) {
          await this.billDetailHp.refreshBilling()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    reconciliationTypeChangeHandler() {
      if (this.reconciliationType === 'job') {
        this.queryJobOfBilling()
      } else if (this.reconciliationType === 'charge') {
        this.queryChargeOfBilling()
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  &.oversea-bill-detail {
    .el-dialog {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .el-dialog__body{
      flex:1;
      overflow: scroll;
    }
    .el-scrollbar {
      &__view {
        display: flex;
        flex-direction: column;
      }
    }
    &-form-wrapper {
      .el-form-item__content {
        width: auto;
      }
    }
  }
}
</style>
